let m_addMember = {
  state: {
    purviewList: [{
        name: '企业查看',
        code: '10000000-0000-0000-0000-000000000001'
      },
      {
        name: '企业管理',
        code: '10000000-0000-0000-0000-000000000002'
      },
      {
        name: '职位管理',
        code: '10000000-0000-0000-0000-000000000003'
      },
      {
        name: '生成账号',
        code: '10000000-0000-0000-0000-000000000004'
      },
      {
        name: '职位审核',
        code: '10000000-0000-0000-0000-000000000011'
      },
      {
        name: '职位列表',
        code: '10000000-0000-0000-0000-000000000021'
      },
      {
        name: '人才查询',
        code: '20000000-0000-0000-0000-000000000001'
      },
      {
        name: '新增人才',
        code: '20000000-0000-0000-0000-000000000002'
      },
      {
        name: '人才认领',
        code: '20000000-0000-0000-0000-000000000003'
      },
      {
        name: '解析渠道',
        code: '20000000-0000-0000-0000-000000000011'
      },
      {
        name: '电话中心',
        code: '20000000-0000-0000-0000-000000000021'
      },
      {
        name: '申请管理',
        code: '20000000-0000-0000-0000-000000000031'
      },
      {
        name: '机构管理',
        code: '30000000-0000-0000-0000-000000000001'
      },
      {
        name: '人员管理',
        code: '30000000-0000-0000-0000-000000000011'
      },
      {
        name: '权限管理',
        code: '30000000-0000-0000-0000-000000000033'
      },
      {
        name: '系统设置',
        code: '30000000-0000-0000-0000-000000000099'
      }
    ],
    //实习生
    probation: [
      {
        name: '企业查看',
        code: '10000000-0000-0000-0000-000000000001'
      },
      {
        name: '职位管理',
        code: '10000000-0000-0000-0000-000000000003'
      },
      {
        name: '新增人才',
        code: '20000000-0000-0000-0000-000000000002'
      },
      {
        name: '人才查询',
        code: '20000000-0000-0000-0000-000000000001'
      },
      {
        name: '电话中心',
        code: '20000000-0000-0000-0000-000000000021'
      },
      {
        name: '职位列表',
        code: '10000000-0000-0000-0000-000000000021'
      },
      //还有个呼叫中心吗
      {
        name: '申请管理',
        code: '20000000-0000-0000-0000-000000000031'
      },
      
    ],
    //专员
    fullTime: [{
        name: '人才认领',
        code: '20000000-0000-0000-0000-000000000003'
      
    }],
    //主管
    manager: [
      {
        name: '生成账号',
        code: '10000000-0000-0000-0000-000000000004'
      }, {
        name: '职位审核',
        code: '10000000-0000-0000-0000-000000000011'
      },
      {
        name: '企业管理',
        code: '10000000-0000-0000-0000-000000000002'
      },
    ],
    //城市经理
    cityManager: [
      {
        name: '人员管理',
        code: '30000000-0000-0000-0000-000000000011'
      },
      {
        name: '机构管理',
        code: '30000000-0000-0000-0000-000000000001'
      },
      {
        name: '权限管理',
        code: '30000000-0000-0000-0000-000000000033'
      }
    ],
    //总管理员
    fullManager: [
      {
        name: '解析渠道',
        code: '20000000-0000-0000-0000-000000000011'
      },
      {
        name: '系统设置',
        code: '30000000-0000-0000-0000-000000000099'
      }
    ],
  },
  getters: {},
  mutations: {},
  actions: {

  }
};

export default m_addMember;